import { Component, Input, NgZone } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { HomePage } from '../../pages/home/home';

//import {Contacts, ContactFindOptions} from 'ionic-native';

//import { TasksDetailComponent } from '../tasks-detail/tasks-detail';
import { Task } from '../../providers/task';
import { User } from '../../providers/user';

declare var braintree: any;

@Component({
  selector: 'voucher',
  templateUrl: 'voucher.html'
})
export class VoucherComponent {

  @Input() profile: any = {};
  @Input() entry: any = {
    id: '',
    title: '',
    time: '', // h:m
    amount: '',
    transfer: 'false',
    nights:'',
    link: '',
    likes: [],
    comments: []
  };
  submitted: boolean = false;
  dayInvalid: boolean = false;
  commentText:any;
  busy: boolean = true;

  constructor(
    public nav: NavController,
    public navParams: NavParams,
    public task: Task,
    public user: User,
    public storage: Storage,
    public zone: NgZone,
    public alert: AlertController
  ) {

    user.isNotConnected().then((user) => {
      debugger;
      if (user) {
        this.user.authAnonymous();
      }
    });
    debugger;
    var id = this.navParams.get("id");
    if(id == ':id' || id == '')
       this.nav.setRoot(HomePage);    
    else if(id != undefined)    
      this.bootstrap(id);

  }

  bootstrap(id:any) {
    debugger;
    this.busy = true;
    console.info('task:bootstrap');

    // try to load from Network
    this.task.ref().then((path) => {
      debugger;
      this.task.db().ref(path+"/"+id).on('value', (snapshot) => {
        this.zone.run(() => { // workaround to get it updated instantly on the view
          debugger;
          this.entry =  JSON.parse(JSON.stringify(snapshot));
          this.entry.id = id;
          this.busy = false;
        });
      }, (e) => { this.busy = false; debugger; console.debug(e); });
    }, (e) => { this.busy = false; debugger; console.debug(e); });

    // try to load itens from cache after 10 seconds, user can maybe be offline or running with slow connection
    setTimeout(() => {
      this.busy = false;
    }, 10000);
  }

  today() : String{
    return new Date().toISOString();
  }

  onLike(event: Event, entry?: any) {
    event.preventDefault();
    console.info(JSON.stringify(this.user.profile()));
    if(entry.likes == undefined)
      entry.likes = [];
    entry.likes.indexOf(this.user.profile().email) === -1 ? entry.likes.push(this.user.profile().email) : entry.likes.pop(this.user.profile().email);
    this.task
        .save(entry)
        .then(() => {
          console.info(`task ${entry.title} saved`);
        }).catch((e) => { console.error(e); });
  }

  // onDetail(data?: any) 
  // {
  //   this.nav.push(TasksDetailComponent, data);
  // }

  saveComment()
  {

    if(this.entry.comments == undefined)
    {
      this.entry.comments = []
    }
    this.entry.comments.push({id:'', image:this.user.profile().photoURL, name:this.user.profile().displayName, createdAt:this.today(), createdby:this.user.profile().email, text: this.commentText});

    this.task
        .save(this.entry)
        .then(() => {
          console.info(`task ${this.entry.title} saved`);
          this.commentText = '';
        }).catch((e) => { console.error(e); });
  }

  numberOfLikes(likes)
  {
    if(likes != undefined)
    {
      //alert(JSON.stringify(likes));
      try
      {
        return likes.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
  }

  timeSince(time: any) {
    //console.info(time);
    if(time != undefined)
    {
      switch (typeof time) {
        case 'number':
          break;
        case 'string':
          time = +new Date(time);
          break;
        case 'object':
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      var time_formats = [
        [60, 'seconds', 1], // 60
        [120, '1 minute ago', '1 minute from now'], // 60*2
        [3600, 'minutes', 60], // 60*60, 60
        [7200, '1 hour ago', '1 hour from now'], // 60*60*2
        [86400, 'hours', 3600], // 60*60*24, 60*60
        [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
        [604800, 'days', 86400], // 60*60*24*7, 60*60*24
        [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
        [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
        [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
        [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
        [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      var seconds = (+new Date() - time) / 1000,
        token = 'ago',
        list_choice = 1;

      if (seconds == 0) {
        return 'Just now'
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = 'from now';
        list_choice = 2;
      }
      var i = 0,
        format;
      while (format = time_formats[i++])
        if (seconds < format[0]) {
          if (typeof format[2] == 'string')
            return format[list_choice];
          else
            return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
        }
      return time;
    }
    else
    {
      return 'NAN';
    }
}

  numberOfComments(comments: any)
  {
    if(comments != undefined)
    {
      //alert(JSON.stringify(comments));
      try
      {
        return comments.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
    else
    {
      return 0;
    }
  }

  onCopy(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  formatDate(dateString)
  {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var date = new Date(dateString);
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }
  taskUpdate(form) {
    this.submitted = true;
    if (form.valid && !this.dayInvalid) {
      this.task
        .save(this.entry)
        .then(() => {
          console.info(`task ${this.entry.title} saved`);
          this.nav.pop(); //back to listing
        }).catch((e) => { console.error(e); });
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/voucher/voucher.ts